export enum DataFieldsEnum {
  NameMemberNr = 'name_membernr',
  Birthday = 'birthday',
  FirstName = 'firstname',
  LastName = 'lastname',
  Address = 'address',
  ShortAdress = 'shortaddress',
  Phone = 'phone',
  PhoneOther = 'phoneother',
  UserName = 'username',
  UserPwd = 'userpwd',
}
